/* eslint-disable import/no-default-export */
import { State } from 'app/gamma/src/modules/types';

// It can be convenient to not fire certain actions when we're using the redux
// dev tools to manually move between states; e.g. something that might get
// triggered from a componentDidMount
export type TimeTravelState = number;
let revision: TimeTravelState = 0;

export default (state = revision) => {
  if (__DEV__) {
    return ++revision;
  }

  return state;
};

export const isTimeTraveling = (state: State) => {
  // Yes, we're assuming that they've named our section of the state "timeTravel"
  return __DEV__ && state.timeTravel !== revision;
};
